import { styled } from "@mui/material/styles";
import {
  Menu as MuiMenu,
} from "@mui/material";


export const CustomMenu = styled(MuiMenu)(({ theme }) => ({
  '& .MuiPaper-root': {
    minWidth: 270,
    marginTop: theme.space._200,
    
    color: theme.colors['neutral.50'],
    backgroundColor: theme.colors["neutral.900"],

    borderRadius: theme.space._400,
    border: `1px solid ${theme.colors["neutral.950"]}`,

    '.MuiMenu-list': {
      padding: 0
    },

    '.MuiList-root': {
      display: "flex",
      flexDirection: "column",
      rowGap: theme.space._400,

      "@media (max-width: 600px)": {
        rowGap: "0",
      },
    },

    '.MuiListItemIcon-root': {
      color: theme.colors['pink.500'],
    },
    
    '.MuiMenuItem-root': {
      padding: 0,
      fontFamily: theme.fonts.default,
      fontSize: theme.fontSizes.md,

      '.MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.colors['neutral.50'],
      },
    },
  },
}));
